module.exports = __webpack_public_path__ + "media/images/players/WOLFF_MATTHEW-b6cd4f9ddd18efbdfaae2cde55a2f445.png";